// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loadable_wrapper__gG4Jh {
  position: relative;
}

.Loadable_contentHidden__IwdJp {
  animation: Loadable_content-hide__nZUCL 0.3s forwards;
}

.Loadable_spinner__gm8VE {
  position: absolute;
  left: calc(50% - 45px);
  top: calc(50% - 7px);
  max-height: 100%;
  transform: scale(0.7);
}`, "",{"version":3,"sources":["webpack://./../../packages/sdk/src/components/ui/Loadable/Loadable.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAKE;EACE,qDAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;AAHF","sourcesContent":[".wrapper {\n  position: relative;\n}\n\n.content {\n  //animation: content-hide 0.2s forwards reverse;\n\n  &Hidden {\n    animation: content-hide 0.3s forwards;\n  }\n}\n\n.spinner {\n  position: absolute;\n  left: calc(50% - 45px);\n  top: calc(50% - 7px);\n  max-height: 100%;\n  transform: scale(0.7);\n}\n\n//@keyframes content-hide {\n//  0% {\n//    opacity: 1;\n//  }\n//\n//  100% {\n//    opacity: 0;\n//    visibility: hidden;\n//  }\n//}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Loadable_wrapper__gG4Jh`,
	"contentHidden": `Loadable_contentHidden__IwdJp`,
	"content-hide": `Loadable_content-hide__nZUCL`,
	"spinner": `Loadable_spinner__gm8VE`
};
export default ___CSS_LOADER_EXPORT___;
